var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeedingEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Speeding Events",
    role: "img",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Speeding Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.99704 10.5c0 5.79999-9.99704 14.5-9.99704 14.5s-9.99704-8.70001-9.99704-14.5c-.13471-5.65964 4.33923-10.3587 9.99704-10.5 5.65781.1413 10.13175 4.84036 9.99704 10.5z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.67278 9.81067c.00098 2.39307-1.29063 4.61621-3.37009 5.7998-.0781.04395-.16304.06543-.247.06543-.17378 0-.34267-.09082-.43444-.25293-.13668-.24023-.05272-.54492.18744-.68164 1.76803-1.00684 2.86536-2.896 2.86439-4.93115.00098-.78809-.15816-1.55273-.47154-2.27344-.11032-.25293.00488-.54785.25774-.6582.25383-.1084.54769.00537.65801.25879.37001.84766.55648 1.74756.5555 2.67334zm-9.55967 4.90332c-1.74948-1.00586-2.83754-2.88574-2.83949-4.90186.01074-3.1333 2.56223-5.67529 5.6946-5.67529.00732-.00049.01611-.00146.02489 0 .80933 0 1.59425.16699 2.33427.49658.24797.11279.54769-.00049.65996-.25293s-.00098-.54785-.25383-.66016c-.86791-.38721-1.78951-.5835-2.73845-.5835h-.02929c-3.67908 0-6.67917 2.98828-6.69186 6.67383.00195 2.375 1.28233 4.58594 3.34129 5.77051.0781.04492.16401.06641.24846.06641.17329 0 .34121-.08984.43395-.25098.13765-.23926.05516-.54492-.18452-.68262zm4.52008-5.82709c.15376.27509.24901.58728.24901.92426 0 1.05225-.85619 1.90869-1.90813 1.90869-1.05242 0-1.90861-.85645-1.90861-1.90869 0-1.05273.85619-1.90918 1.90861-1.90918.35182 0 .67753.10242.96084.26929l3.17124-3.17261c.19525-.19531.51157-.19531.70682 0s.19525.51172 0 .70703zm-.75069.92426c0-.50146-.40759-.90918-.90842-.90918-.50132 0-.90891.40771-.90891.90918 0 .50098.40759.90869.90891.90869.50083 0 .90842-.40771.90842-.90869z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedingEventsPoint);
export default __webpack_public_path__ + "static/media/speeding-events-point.8338732c498c48073b2f34c0fea73adc.svg";
export { ForwardRef as ReactComponent };